<!-- Modal.vue -->
<template>
  <div class="modal-wrapper">
    <div v-if="isOpen" class="modal-overlay">
      <div class="dimmed-background" @click="close"></div>
      <div class="modal-container">
        <div class="modal-head">
          <h2 class="modal-title">{{ title }}</h2>
          <button @click="close" class="close-button">
          </button>
        </div>
        <div class="modal-cont">
          <slot></slot>
        </div>
        <div v-if="originalPrice && discountedPrice" class="price-section">
          <div class="price-content">
            <span class="original-price">정가 <span>{{ originalPrice.toLocaleString() }}</span>원</span>
            <span class="text-wrap">
              <span class="discount-badge" :class="{ 'text-type': displayType === 'coupon' }">
                {{ displayType === 'coupon' ? '쿠폰가' : `-${discountPercent}%` }}
              </span>
              <span class="final-price">{{ discountedPrice.toLocaleString() }}원</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    originalPrice: {
      type: Number,
      default: null
    },
    discountedPrice: {
      type: Number,
      default: null
    },
    displayType: {
      type: String,
      default: 'percent' // 기본값은 퍼센트 표시
    }
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.lockScroll()
      } else {
        this.unlockScroll()
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    lockScroll() {
      // 현재 스크롤 위치 저장
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollPosition}px`
      document.body.style.width = '100%'
    },
    unlockScroll() {
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('position')
      document.body.style.removeProperty('top')
      document.body.style.removeProperty('width')
      window.scrollTo(0, this.scrollPosition)
    }
  },
  beforeDestroy() {
    // 컴포넌트가 제거될 때 스크롤 잠금 해제
    if (this.isOpen) {
      this.unlockScroll()
    }
  },
  data() {
    return {
      scrollPosition: 0
    }
  },
  computed: {
    discountPercent() {
      if (!this.originalPrice || !this.discountedPrice) return 0;
      return Math.floor(((this.originalPrice - this.discountedPrice) / this.originalPrice) * 100);
    }
  }
}
</script>

<style scoped>

button {
  border: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  text-align: center;
}

.dimmed-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(7px);
}

.modal-container {
  position: relative;
  background: white;
  width: 714px;
  max-width: 714px;
  min-height: 378px;
  max-height: 94%;
  border-radius: 18px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding-bottom: 66px;
  overflow-y: auto;
  z-index: 10000;
}

.modal-head {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 34px 20px 0;
}

.modal-title {
  font-size: 42px;
  font-weight: 600;
  line-height: 88px;
  letter-spacing: -0.02em;
  color: #000;
}

.close-button {
  position: absolute;
  right: 38px;
  top: 31px;
  display: inline-block;
  width: 51px;
  height: 51px;
  background: url(../../assets/c28/ico-cross-black.png) no-repeat center/cover;
  border-radius: 6px;
}

.close-button:hover {
  background-color: #f3f4f6;
}

.main-space {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.box {
  margin-top: 32px;
  width: 613px;
  max-width: 613px;
  padding: 24px 35px;
  border-radius: 20px;
  background-color: #f7f7f7;
}

.box > div + div {
  margin-top: 20px;
}

.box.type02 {
 margin-bottom: -12px;
}

.info-title {
  margin-top: 22px;
  font-weight: 400;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: -0.02em;
  color: #434343;
}

.section-title {
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: -0.02em;
  color: #00B3AE;
}

.box-title {
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: -0.02em;
  color: #434343;
}

.box-text {
  padding: 0 30px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: -0.02em;
  color: #434343;
  word-break: keep-all;
}

.box-text.type02 {
 padding: 0 10px;
}

.price-section {
  padding: 16px 20px;
  /* background-color: #f9fafb; */
}

.price-content {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 56px;
}

.original-price {
  color: #999;
  font-size: 26px;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: -0.02em;
}

.original-price span {
  text-decoration: line-through;
}

.discount-badge {
  margin-right: 14px;
  padding: 2px 2px;
  background-color: #DA3C3E;
  color: #fff;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  border-radius: 5px;
}

.discount-badge.text-type {
  font-size: 26px;
  padding: 2px 7px;
  margin-right: 8px;
}

.final-price {
  font-size: 38px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 42px;
  color: #333;
}

.text-wrap {
  display: flex;
  align-items: center;
}

@media (max-width: 767.98px) {
  .modal-title {
    font-size: 22px;
    line-height: 46px;
  }
  .close-button {
    width: 27px;
    height: 27px;
    top: 16px;
    right: 20px;
  }
  .modal-head {
    padding-top: 16px;
  }
  .modal-container {
    width: calc(100% - 40px);
    border-radius: 10px;
    padding-bottom: 30px;
    min-height: auto;
    min-width: auto;

  }
  .modal-container:has(.box.type02) {
    padding-bottom: 30px;
  }
  .main-space {
    width: 100%;
  }
  .info-title {
    font-size: 15px;
    line-height: 22px;
    margin-top: 12px;
  }
  .box {
    width: calc(100% - 50px);
    padding: 13px 18px;
    padding-bottom: 20px;
    border-radius: 10px;
    margin-top: 16px;
  }
  .box > div + div {
    margin-top: 6px;
  }

  .section-title, .box-title {
    font-size: 15px;
    line-height: 22px;
  }
  .box-text {
    margin-top: 6px;
    font-size: 15px;
    line-height: 22px;
  }
  .box-text.type02 {
    font-size: 15px;
    line-height: 22px;
    padding:0;
  }
  .original-price {
    font-size: 15px;
    line-height: 22px;
  }
  .price-section {
    padding: 10px 20px;
  }
  .price-content {
    margin-top: 20px;
    gap: 21px;
  }
  .discount-badge {
    margin-right: 6px;
    padding: 2px 2px;
    background-color: #DA3C3E;
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    border-radius: 3px;
  }
  .discount-badge.text-type {
    font-size: 14px;
    margin-right: 6px;
  }
  .final-price {
    font-size: 22px;
    line-height: 22px;
  }
  .box-text {
    padding: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal.vue